// extracted by mini-css-extract-plugin
export var menuIcon = "_ry-0";
export var menuIconInline = "_ry-1";